import { RouteNode } from '@coool/route-node';

export const SERVER_URL_PREFIX = 'api';

export const ServerUrls = {
  Visitor: new RouteNode('visitors', {
    Identify: new RouteNode(),
    Events: new RouteNode(),
    Error: new RouteNode(),
  }),

  Companies: new RouteNode('companies', {
    GetAvailable: new RouteNode(),
    Create: new RouteNode(),
  }),

  KnowledgeBases: new RouteNode('knowledge-bases', {
    Get: new RouteNode(),
    Upsert: new RouteNode(),
    ById: new RouteNode(':knowledgeBaseId', {
      Get: new RouteNode(),
      Delete: new RouteNode(),

      Domains: new RouteNode('domains', {
        Get: new RouteNode(),
        Create: new RouteNode(),

        ById: new RouteNode(':domainId', {
          Delete: new RouteNode(),
        }, {
          params: {
            domainId: 'domainId',
          },
        }),
      }),

      Categories: new RouteNode('categories', {
        Get: new RouteNode(),
        Create: new RouteNode(),

        ById: new RouteNode(':categoryId', {
          Delete: new RouteNode(),
        }, {
          params: {
            categoryId: 'categoryId',
          },
        }),
      }),
    }, {
      params: {
        knowledgeBaseId: 'knowledgeBaseId',
      },
    }),
  }),

  HelpSite: new RouteNode('help-site', {
    Data: new RouteNode('data', {
      Get: new RouteNode('', undefined, {
        queryParams: {
          language: 'language'
        }
      }),
    }),
  }),

  Authentications: new RouteNode('authentications', {
    Auth0: new RouteNode('auth0', {
      Login: new RouteNode('login'),
      Callback: new RouteNode('callback'),
    }),
    Session: new RouteNode('session', {
      CreateNew: new RouteNode(),
      OneTimeToken: new RouteNode('one-time-token'),
      FromOneTimeToken: new RouteNode('from-one-time-token'),
    }),
    Logout: new RouteNode('logout'),
  }),

  Health: new RouteNode('health', {
    Check: new RouteNode(),
    HTMLCheck: new RouteNode('html'),
    Info: new RouteNode('info'),
  }),
};